.tabs {
	width: 100%;
	border-bottom: 1px solid var(--border-primary);
	display: flex;
	justify-content: flex-start;
	align-items: center;
	padding-inline: 16px;
	gap: 8px;
	box-sizing: border-box;
	height: 36px;
}

.tab {
	color: var(--content-primary);
	cursor: pointer;
	padding: 8px;
	text-decoration: none;
	box-sizing: border-box;
}

.tab[aria-disabled="true"] {
	color: var(--content-tertiary);
	cursor: not-allowed;

	padding: 8px !important;
	border-bottom: none !important;
}

.tab:focus-visible {
	outline: var(--focus-outline);
	outline-offset: var(--focus-outline-offset);
}

.tab:hover,
.active {
	padding-bottom: 6px;
	border-bottom: 2px solid var(--background-secondary);
}
